import { Entity } from "@shapeable/types";

export const filterEntitiesWithLinkedSite = (entities: Entity[]): Entity[] => {
  return entities.filter(entity => !!entity?.site);
};
